module.exports = __webpack_public_path__ + "img/PGR_A05_front_en.9f3b00cc.png";